<template>
  <div class="body">
    <div class="body-logo">
      <img :src="big.filepath" />
    </div>
    <div class="body-navs">
      <div v-for="(item, index) in navs"
           :key="index"
           :class="{ 'body-navs-nav': true, 'body-navs-navOn': id == item.id }"
           @click="onChangeNav(item.id)">
        {{item.name}}
      </div>
    </div>
    <div class="body-content"
         v-if="news.length > 0 ">
      <div class="body-content-box2"
           v-for="(item, i) in news"
           :key="'new' + i"
           @click="showDetailVisible(item.id)">
        <div class="body-content-box2-img">
          <img :src="item.filepath" />
        </div>
        <div class="body-content-box2-context">
          <div class="body-content-box2-context-title">
            {{ item.title }}
          </div>
          <div class="body-content-box2-context-msg">
            {{ item.jianjie }}
          </div>
        </div>
        <div class="body-content-box2-times">
          <div class="body-content-box2-times-dd">
            {{ item.dd }}
          </div>
          <div class="body-content-box2-times-yymm">
            {{ item.yymm }}
          </div>
        </div>
      </div>
      <div class="nws-page">
        <el-pagination background
                       layout="prev, pager, next"
                       hide-on-single-page
                       :page-size="pagesize"
                       :total="total"
                       :current-page.sync="page"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <!-- 空状态 -->
    </div>
    <div class="body-content"
         v-else>
      <el-empty description="暂无新闻"></el-empty>
    </div>

  </div>
</template>

<script>

import { getchild, getnews } from "@/service/index";
export default {

  data () {
    return {
      id: 0,
      page: 1,
      pagesize: 8,
      total: 0,
      big: [],
      navs: [],
      news: [],

    };
  },
  mounted () {
    let id = this.$route.query.id != undefined ? this.$route.query.id : 0;
    this.id = id;
    this.page = 1;
    this.getchild(2);
  },
  methods: {
    handleCurrentChange (val) {
      this.page = val;
      this.getnews();
    },
    getchild (cateid) {
      getchild({ cateid: cateid }).then(res => {

        this.big = res.data.big;
        this.navs = res.data.menu;
        // 判断如果ID为0则显示第一个
        if (this.id == 0) {
          this.id = res.data.menu[0].id;
        }
        this.getnews();

      });
    },
    getnews () {
      getnews({ id: this.id, page: this.page, pagesize: this.pagesize }).then(res => {
        this.last_page = res.last_page;
        this.total = res.data.total;
        this.news = res.data.data;
      })
    },
    onChangeNav (id) {
      this.page = 1;
      this.id = id;
      this.getnews();

    },


    showDetailVisible (id) {

      this.$router.push(
        {
          path: '/detial',
          query: {
            id: id
          }
        }
      )

    }
  },
};
</script>
<style scoped lang="scss" src="./index.scss">
</style>
